import { LogoSpinner } from "@/components/logo-spinner";

export const Route = createFileRoute({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex items-center justify-center h-screen">
      <LogoSpinner />
    </div>
  );
}
